/*
 * pdp-explore.js
 * ---------------------------------------------------------------
 * Quick add for the Explore more row.
 *
 * The version this replaces had three problems. It bound listeners on
 * DOMContentLoaded, which never fires again after a theme-editor
 * re-render, so quick add stopped working the moment anyone touched the
 * section in the customiser. It replaced the button's text with a tick
 * and left it that way for ever, so a second purchase was impossible.
 * And it reported failure with alert().
 *
 * Vanilla ES6, no dependencies.
 * ---------------------------------------------------------------
 */

(function () {
  'use strict';

  var RESET_AFTER = 2600;

  function announce(root, message) {
    var live = root.querySelector('[data-explore-live]');
    if (live) live.textContent = message;
  }

  /*
   * Tell the theme the cart changed. Dawn's cart drawer listens for its
   * own pub/sub, which is module-scoped and not reachable from here, so
   * the count bubbles are updated directly and a bubbling event is
   * dispatched for anything else that is listening.
   */
  function refreshCart(root) {
    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;

        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble && cart.item_count > 0) bubble.hidden = false;

        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
        );
      })
      .catch(function () {
        /* The item is in the cart either way; a stale badge is not worth
           an error message. */
      });
  }

  function add(button, root) {
    var id = button.getAttribute('data-variant-id');
    if (!id || button.classList.contains('is-busy')) return;

    button.classList.add('is-busy');
    button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Could not add');
          return body;
        });
      })
      .then(function () {
        button.classList.remove('is-busy');
        button.classList.add('is-added');
        button.disabled = false;
        button.setAttribute('aria-label', 'Added to cart');
        announce(root, (button.getAttribute('data-title') || 'Item') + ' added to your cart');
        refreshCart(root);

        /* Back to a plus, so the same product can be added again. */
        window.setTimeout(function () {
          button.classList.remove('is-added');
          button.setAttribute('aria-label', button.getAttribute('data-label') || 'Add to cart');
        }, RESET_AFTER);
      })
      .catch(function (error) {
        button.classList.remove('is-busy');
        button.disabled = false;
        announce(root, error.message || 'Sorry, that could not be added.');
      });
  }

  function setup(root) {
    if (root.dataset.exploreReady === 'true') return;
    root.dataset.exploreReady = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-explore-add]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      add(button, root);
    });
  }

  function init() {
    document.querySelectorAll('[data-explore]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor replaces a section's markup wholesale. Without
     these the section is live in the preview but its buttons are not. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-explore]').forEach(setup);
  });
  document.addEventListener('shopify:section:select', init);
})();
